module.exports = __webpack_public_path__ + "static/media/guntekinonay.61bde740.png";